
(function () {
  function syncInterests(form) {
    if (!form || !form.closest('.mg-newsletter')) return;
    const tags = form.querySelector('[data-mg-newsletter-tags]');
    if (!tags) return;
    const interests = Array.from(form.querySelectorAll('[data-mg-newsletter-interest]:checked'), input => input.value);
    const value = ['prospect', 'newsletter', ...interests].join(',');
    tags.value = value;
    tags.setAttribute('value', value);
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-mg-newsletter-interest]')) syncInterests(event.target.closest('form'));
  }, true);
  document.addEventListener('submit', function (event) { syncInterests(event.target); }, true);
})();
